import React, { useEffect } from "react";
import EventCardView from "../cards/EventCardView";
import DrawCardDeck from "../cards/DrawCardDeck";

/**
 * EventsColumn
 * Renders currently active events and the draw-action-card deck stack.
 */
const EventsColumn = ({
  activeEvents = [],
  newEventIds = new Set(),
  setNewEventIds,
  styleCardSize,
  onDrawActionCard,
  canDrawActionCard,
  handFull
}) => {
  // Remove events from newEventIds after animation completes
  useEffect(() => {
    if (newEventIds.size > 0 && setNewEventIds) {
      const timers = [];
      
      // Set up individual timers for each new event
      activeEvents.forEach(event => {
        const eventId = event.id || event.name;
        if (eventId && newEventIds.has(eventId)) {
          const timer = setTimeout(() => {
            setNewEventIds(prev => {
              const updated = new Set(prev);
              updated.delete(eventId);
              return updated;
            });
          }, 2000); // After animation completes
          timers.push(timer);
        }
      });
      
      return () => {
        timers.forEach(timer => clearTimeout(timer));
      };
    }
  }, [activeEvents, newEventIds, setNewEventIds]);
  
  return (
    <div className="events-column" data-tutorial="events">
      {activeEvents.length > 0 && (
        <div className="events-left-aligned">
          {activeEvents.map((event, index) => {
            const eventId = event.id || event.name || `event-${index}`;
            const isNew = newEventIds.has(eventId);
            
            return (
              <div key={`event-${index}`} className="events-item">
                <EventCardView event={event} styleCardSize={styleCardSize} isNew={isNew} />
              </div>
            );
          })}
        </div>
      )}

      <div className="events-draw-card-container">
        <DrawCardDeck
          onDraw={onDrawActionCard}
          canDraw={canDrawActionCard}
          handFull={handFull}
          styleCardSize={styleCardSize}
        />
      </div>
    </div>
  );
};

export default EventsColumn;


